/* eslint-disable react/display-name */
import * as React from "react";
import Container from "react-bootstrap/Container";
import Button from "react-bootstrap/Button";

import {
  searchContainer,
  emptyHotelsRow,
  displaySwitch,
  mobileFilterToggle,
} from "./SearchResult.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { memo } from "react";
import { PromoAlertProps } from "./SearchResultProps";
import { Alert, Col, Row } from "react-bootstrap";

export const SearchContainer: React.FC<any> = memo((props) => {
  return (
    <Container
      className={`${searchContainer} mb-5`}
      style={{ backgroundColor: props.background }}
      fluid="sm"
      id={props.cid}
    >
      {props.children}
    </Container>
  );
});

export const EmptyHotelsRow: React.FC<any> = memo((props) => {
  return <div className={`${emptyHotelsRow} p-3`}>{props.children}</div>;
});

export const DisplaySwitch: React.FC<any> = memo((props) => {
  return <div className={displaySwitch}>{props.children}</div>;
});

export const MobileFilterToggle: React.FC<any> = memo((props) => {
  return (
    <Button
      className={`${mobileFilterToggle} w-100 text-left d-block d-lg-none ${
        !props.openFilter && "mb-4"
      }`}
      onClick={props.onClick}
      aria-controls="searchFilters"
      aria-expanded={props.openFilter}
    >
      {props.children}
    </Button>
  );
});

export const LocationAccessPrompt: React.FC = memo(() => (
  <EmptyHotelsRow>
    <FontAwesomeIcon icon="exclamation-circle" className="me-1" />
    <span>
      Location needs to be enabled in order to discover hotels nearby.
      <br /> Please allow access to your location or check our{" "}
      <a href="/locations">hotel locations page</a>.
    </span>
  </EmptyHotelsRow>
));

export const NoHotelsFound: React.FC = memo(() => {
  return (
    <EmptyHotelsRow>
      <FontAwesomeIcon icon="exclamation-circle" className="me-1" />
      <span>
        We couldn&apos;t find any hotels for you in this area.
        <br /> Please try searching for another location or check our{" "}
        <a href="/locations">hotel locations page</a>
      </span>
    </EmptyHotelsRow>
  );
});

/**
 * Component to display a promotional alert message.
 * It shows an alert if a promo code is invalid for the selected dates.
 */
export const PromoAlert: React.FC<PromoAlertProps> = ({
  shouldDisplayPromoMessage,
  isPromoValid,
  promotionCode,
  groupCode,
  handlePromoMessageAlert,
}) => {
  // Only render the Alert if it should be displayed and the promo is not valid
  if (!shouldDisplayPromoMessage || isPromoValid) {
    return null;
  }
  const discountType = promotionCode ? "promo code" : "group code";
  const discountCode = promotionCode || groupCode;
  return (
    <Row className="pt-3 pb-4">
      <Col>
        <Alert onClose={handlePromoMessageAlert} dismissible transition>
          The {discountType} <strong>{discountCode?.toUpperCase()}</strong> is
          unavailable for the selected dates. We are showing the lowest
          available rates.
        </Alert>
      </Col>
    </Row>
  );
};

export const convertArrayToObject = (array: Hotel[], key: keyof Hotel) => {
  return array.reduce((obj, item) => {
    const keyValue = item[key];
    if (typeof keyValue === "string") {
      obj[keyValue] = item;
    }
    return obj;
  }, {} as Record<string, Hotel>);
};
